<template>
<div class="rvs-container text-left text-sm">
    <div class="rvs-item-container">
        <div class="rvs-item-stage">
            <div class="rvs-item" v-for="video in videos" :style="{backgroundImage:'url(/images/videoplayer/'+video.id+'.maxresdefault.jpg)'}">
                <a :href="'https://www.youtube.com/watch?v='+video.id" class="rvs-play-video"></a>
            </div>
        </div>
        <div class="rvs-nav-container">
            <a class="rvs-nav-prev"></a>
            <div class="rvs-nav-stage">
                <a class="rvs-nav-item" v-for="video in videos">
                    <span class="rvs-nav-item-thumb" :style="{backgroundImage:'url(/images/videoplayer/'+video.id+'.hqdefault.jpg)'}"></span>
                    <h4 class="rvs-nav-item-title" v-text="video.title"></h4>
                    <small class="rvs-nav-item-credits"  v-text="video.author"></small>
                </a>
            </div>
            <a class="rvs-nav-next"></a>
        </div>
    </div>
</div>
</template>
<script>
export default {
    data() {
        return {
            videos: [
            {id:'LnsG4zoVtYw',title:'Huge Tangent Templates Update! Cover Designer, Picture Book Coloring Books, KDP, Printables + more!!'},
            {id:'wfNLw75OLVY',title:'TT Turbo rapid book creation. Made these in my car with ChatGPT Tangent Templates, KDP'},
            {id:'gjdcsZF8_rI',title:'Publish your AI art on KDP using Tangent Templates. Journals, book covers, printables! | Midjourney'},
            {id:'dW36TkIxGus',title:'KDP and Printables - More awesome free TT Templates for you to edit & customize! Bonus Eco Niches!'},
            {id:'Pfxsl6HrcD4',title:'KDP friends! Welcome to the FREE Tangent Magazine #1 - Niches, Ideas, templates, ChatGPT and more!'},

            // {id:'6ssuH9DXnXA',title:'Tangent Template Update - Upload your own PDF Interior Pages. Mix and Match KDP Interiors.'},
            // {id:'Ra9oKzWniwE',title:'KDP PDF Print Ready PDF covers - PhotoShop or Canva - SUPER FAST and Easy.'},
            // {id:'vFyvwc83TVE',title:'KDP Tangent Templates Update- Category Selection in Listing Helper, Keyword Categories plus A4 Sizes'},
            // {id:'fXupIy9W-TY',title:'Planners, Prompts and Guided Journals. Dynamic Templates in Tangent Templates',author:'Katharyne Shelton'},
            // {id:'mq5lVoQNRBg',title:'KDP Complete Walkthrough - Publishing a Guided Journal on Amazon with Tangent Templates Prompts',author:'Katharyne Shelton'},
            // {id:'bwrEGiuRx0g',title:'HUGE Tangent Template Update (CreateSpace and KDP book building tool)',author:'Katharyne Shelton'},
            // {id:'Dlf-3GnHIbg',title:'Journals & Books - Customize Tangent Template interiors',author:'Isaac Gonzalez'},
            // {id:'uPlnSkKBsQg',title:'Custom KDP Interiors using Keynote - Plus Merging in Tangent Templates',author:'Katharyne Shelton'},
            // {id:'OPHsCQGrFgw',title:'KDP Book Covers Full Walkthrough in Canva - Beautiful, Fast and Easy',author:'Katharyne Shelton'},
            // {id:'5_wYBAH_25s',title:'KDP - 5 Ways to find killer niches and trends for blank books, journals and notebooks!',author:'Katharyne Shelton'},
            // {id:'IQeBPYeqfB8',title:'Everything you need to know about keywords for KDP!',author:'Katharyne Shelton'},
            // {id:'EuIheHN5j9c',title:'See Like an Artist with Isaac Gonzalez - Graphic Design for T-Shirts and beyond!',author:'Isaac Gonzalez'},
            // {id:'_PzOygoCo1s',title:'Author Brand + Marketing, my response to Amazon KDP Promotional Strategy Webinar. Controversial? :D',author:'Katharyne Shelton'},
            // {id:'uPlnSkKBsQg',title:'Custom KDP Interiors using Keynote - Plus Merging in Tangent Templates',author:'Katharyne Shelton'},
            // {id:'rhvc9SuWZUM',title:'Publishing KDP Book Interiors with Powerpoint plus merging in Tangent Templates',author:'Katharyne Shelton'},
            // {id:'0-UC6HJiFyU',title:'Live Brainstorming - Make your books sell!',author:'Katharyne Shelton'}
            ]
        }
    },
    mounted() {
        jQuery(function($) {
            //$(".rvs-container").rvslider();
        });
    }
}
</script>
